import moment from 'moment'

export const dateToShow = (date, format = 'DD/MM/YYYY') => {
  if (!date) {
    return null
  }
  try {
    return moment(date).format(format)
  } catch (e) {
    return null
  }
}

export const dateToMysql = (date, format = 'YYYY-MM-DD') => {
  if (!date) {
    return null
  }
  try {
    return moment(date, 'DD/MM/YYYY').format(format)
  } catch (e) {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/helpers/dates.js